(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["custom-measurements"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('custom-measurements')) {
    const customMeasurementState = new Map();

    class CustomMeasurements extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.initialized = true;
        this.section = this.closest('.shopify-section') || document;
        this.customSizeValue = this.dataset.customSizeValue || '0';
        this.stateKey = `${this.dataset.sectionId}-${this.dataset.productId}-${this.dataset.blockId}`;
        this.editor = this.querySelector('[data-measurement-editor]');
        this.summary = this.querySelector('[data-measurement-summary]');
        this.error = this.querySelector('[data-measurement-error]');
        this.inputs = Array.from(this.querySelectorAll('[data-measurement]'));
        this.unitButtons = Array.from(this.querySelectorAll('[data-unit-button]'));
        this.propertyInputs = Array.from(this.querySelectorAll('[data-line-property]'));
        this.confirmButton = this.querySelector('[data-confirm-measurements]');
        this.editButton = this.querySelector('[data-edit-measurements]');
        this.currentUnit = this.dataset.defaultUnit || 'in';
        this.confirmed = false;
        this.active = false;

        this.onSectionChange = this.handleSectionChange.bind(this);
        this.onProductSubmit = this.handleProductSubmit.bind(this);

        const savedState = customMeasurementState.get(this.stateKey);
        if (savedState) {
          this.currentUnit = savedState.unit;
          this.confirmed = savedState.confirmed;
        }

        this.unitButtons.forEach((button) => {
          button.addEventListener('click', () => this.changeUnit(button.dataset.unitButton));
        });

        this.inputs.forEach((input) => {
          input.addEventListener('input', () => {
            this.hideError();
            this.saveState();
          });
        });

        this.confirmButton?.addEventListener('click', () => this.confirmMeasurements());
        this.editButton?.addEventListener('click', () => this.editMeasurements());
        this.section.addEventListener('change', this.onSectionChange);

        this.applyUnitSettings();

        if (savedState?.values) {
          this.inputs.forEach((input) => {
            if (savedState.values[input.dataset.key] !== undefined) {
              input.value = savedState.values[input.dataset.key];
            }
          });
        }

        if (this.confirmed) {
          this.renderSummary();
        }

        this.bindProductForm();

        requestAnimationFrame(() => {
          this.updateVisibility();
          this.bindProductForm();
        });
      }

      disconnectedCallback() {
        this.section?.removeEventListener('change', this.onSectionChange);
        this.productForm?.removeEventListener('submit', this.onProductSubmit, true);
      }

      findSizeSelect() {
        const customSelect = this.section.querySelector(
          'variant-custom-select[data-default-value] select[data-native-select]'
        );

        if (customSelect) return customSelect;

        return Array.from(this.section.querySelectorAll('select[name^="options["]')).find((select) => {
          return select.name.toLowerCase().includes('size');
        });
      }

      findProductForm() {
        return (
          this.closest('form[action*="/cart/add"]') ||
          this.section.querySelector('form[action*="/cart/add"]')
        );
      }

      bindProductForm() {
        const form = this.findProductForm();
        if (!form) return;

        if (this.productForm && this.productForm !== form) {
          this.productForm.removeEventListener('submit', this.onProductSubmit, true);
        }

        this.productForm = form;

        if (!this.productForm.id) {
          this.productForm.id = `ProductForm-${this.dataset.sectionId}-${this.dataset.blockId}`;
        }

        this.propertyInputs.forEach((input) => {
          input.setAttribute('form', this.productForm.id);
        });

        this.productForm.removeEventListener('submit', this.onProductSubmit, true);
        this.productForm.addEventListener('submit', this.onProductSubmit, true);
        this.syncProperties();
      }

      handleSectionChange(event) {
        if (!event.target.matches('select[name^="options["]')) return;

        const isSizeSelect =
          event.target.closest('variant-custom-select[data-default-value]') ||
          event.target.name.toLowerCase().includes('size');

        if (!isSizeSelect) return;

        this.updateVisibility(event.target.value);
        setTimeout(() => this.bindProductForm(), 0);
      }

      updateVisibility(selectedValue) {
        const sizeSelect = this.findSizeSelect();
        const value = selectedValue ?? sizeSelect?.value;
        this.active = value === this.customSizeValue;

        if (this.dataset.visualPreview !== undefined && !sizeSelect) {
          this.active = true;
        }

        this.hidden = !this.active;

        if (this.active) {
          this.showConfirmedState();
        }

        this.syncProperties();
      }

      changeUnit(nextUnit) {
        if (!['in', 'cm'].includes(nextUnit) || nextUnit === this.currentUnit) return;

        const previousUnit = this.currentUnit;

        this.inputs.forEach((input) => {
          const value = Number.parseFloat(input.value);
          if (!Number.isFinite(value)) return;

          const inches = previousUnit === 'cm' ? value / 2.54 : value;
          const converted = nextUnit === 'cm' ? inches * 2.54 : inches;
          input.value = this.formatNumber(converted);
        });

        this.currentUnit = nextUnit;
        this.applyUnitSettings();
        this.hideError();
        this.saveState();

        if (this.confirmed) {
          this.renderSummary();
          this.syncProperties();
        }
      }

      applyUnitSettings() {
        const factor = this.currentUnit === 'cm' ? 2.54 : 1;

        this.unitButtons.forEach((button) => {
          button.setAttribute(
            'aria-pressed',
            String(button.dataset.unitButton === this.currentUnit)
          );
        });

        this.querySelectorAll('[data-inline-unit]').forEach((unit) => {
          unit.textContent = this.currentUnit;
        });

        this.inputs.forEach((input) => {
          const min = Number.parseFloat(input.dataset.minIn) * factor;
          const max = Number.parseFloat(input.dataset.maxIn) * factor;
          input.min = this.formatNumber(min);
          input.max = this.formatNumber(max);
          input.placeholder = `${this.formatNumber(min)} – ${this.formatNumber(max)}`;
        });
      }

      validateMeasurements() {
        let firstInvalid;

        this.inputs.forEach((input) => {
          input.setCustomValidity('');

          const value = Number.parseFloat(input.value);
          const min = Number.parseFloat(input.min);
          const max = Number.parseFloat(input.max);

          if (!Number.isFinite(value)) {
            input.setCustomValidity('Please enter this measurement.');
          } else if (value < min || value > max) {
            input.setCustomValidity(
              `Enter a value between ${this.formatNumber(min)} and ${this.formatNumber(max)} ${this.currentUnit}.`
            );
          }

          if (!input.checkValidity() && !firstInvalid) {
            firstInvalid = input;
          }
        });

        if (firstInvalid) {
          this.showError('Please review the highlighted measurements before confirming.');
          firstInvalid.reportValidity();
          firstInvalid.focus();
          return false;
        }

        return true;
      }

      confirmMeasurements() {
        if (!this.validateMeasurements()) return;

        this.confirmed = true;
        this.hideError();
        this.renderSummary();
        this.showConfirmedState();
        this.saveState();
        this.bindProductForm();
        this.syncProperties();
      }

      editMeasurements() {
        this.confirmed = false;
        this.editor.hidden = false;
        this.summary.hidden = true;
        this.saveState();
        this.syncProperties();

        requestAnimationFrame(() => {
          this.inputs[0]?.focus();
        });
      }

      showConfirmedState() {
        this.editor.hidden = this.confirmed;
        this.summary.hidden = !this.confirmed;
      }

      renderSummary() {
        this.inputs.forEach((input) => {
          const output = this.querySelector(`[data-summary-key="${input.dataset.key}"]`);
          if (output) {
            output.textContent = `${this.formatNumber(Number.parseFloat(input.value))} ${this.currentUnit}`;
          }
        });
      }

      syncProperties() {
        const enabled = this.active && this.confirmed && Boolean(this.productForm);

        this.propertyInputs.forEach((input) => {
          input.disabled = !enabled;

          if (input.dataset.lineProperty === 'unit') {
            input.value = this.currentUnit.toUpperCase();
            return;
          }

          if (input.dataset.lineProperty === 'confirmed') return;

          const measurement = this.inputs.find(
            (item) => item.dataset.key === input.dataset.lineProperty
          );

          if (measurement?.value) {
            input.value = `${this.formatNumber(Number.parseFloat(measurement.value))} ${this.currentUnit}`;
          }
        });
      }

      handleProductSubmit(event) {
        this.updateVisibility();

        if (!this.active) return;

        if (!this.confirmed || !this.validateMeasurements()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.editor.hidden = false;
          this.summary.hidden = true;
          this.showError('Confirm your custom measurements before adding this dress to the cart.');
          this.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }

        this.syncProperties();
      }

      saveState() {
        const values = {};

        this.inputs.forEach((input) => {
          values[input.dataset.key] = input.value;
        });

        customMeasurementState.set(this.stateKey, {
          unit: this.currentUnit,
          confirmed: this.confirmed,
          values
        });
      }

      showError(message) {
        if (!this.error) return;
        this.error.textContent = message;
        this.error.hidden = false;
      }

      hideError() {
        if (!this.error) return;
        this.error.hidden = true;
        this.error.textContent = '';
      }

      formatNumber(value) {
        if (!Number.isFinite(value)) return '';
        return String(Math.round(value * 10) / 10);
      }
    }

    customElements.define('custom-measurements', CustomMeasurements);
  }
  } catch(e) { console.error(e); }
})();

})();
